import * as React from 'react'
import { FC } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { AgreementsDrawerTable } from './Table'
import { useGetFormsOnMount } from '@user/store/agreements/hooks/useGetFormsOnMount'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const styles = {
  root: {
    display: 'flex',
    overflowY: 'scroll',
  },
}

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdate: boolean
  openAgreementCreateDrawer?: () => void
}

export const TableWrapper: FC<Props> = (props: Props) => {
  const { entityId, entityType, canUpdate, openAgreementCreateDrawer } = props

  const status = useGetFormsOnMount({
    externalEntityType: entityType.toString(),
    externalEntityId: entityId.toString(),
  })

  return (
    <Box sx={styles.root}>
      {status == 'pending' && (
        <Box p={2} display="flex" justifyContent="center" width="100%">
          <CircularProgress />
        </Box>
      )}
      {status == 'success' && (
        <AgreementsDrawerTable
          canUpdate={canUpdate}
          entityId={entityId}
          entityType={entityType}
          openAgreementCreateDrawer={openAgreementCreateDrawer}
        />
      )}
      {status == 'fail' && (
        <Box p={2} display="flex" justifyContent="center">
          <Alert severity="error">
            Failed to load agreements for this {entityType.toLowerCase()}.
          </Alert>
        </Box>
      )}
    </Box>
  )
}

TableWrapper.displayName = 'TableWrapper'
